export const WorkData = [
    {
        company: "Huawei",
        role: "Software Engineer Intern",
        dateStart: "Jan 2022",
        dateEnd: "Apr 2022",
        copanyLogo: require('./assets/Huawei.png').default,
        work: "Working on OmniRuntime, a cross platform data analytic accelerator. Contributions include implementing various SQL query operator support, performance optimizations, and implementing translator module to parse and convert SQL query to Java expressions"
    },
    {
        company: "Rekammend",
        role: "Software Engineer Intern",
        dateStart: "May 2021",
        dateEnd: "August 2021",
        copanyLogo: require('./assets/reka-nobg.png').default,
        work: "Designed and built backend REST API services using Express.js and MongoDB for user storage and extraction, user usage tracking, in app suggestions, and much more. Implemented frontend design using Swift and SwiftUI and worked on middle end development to ensure functionality"
    }
]